import { render } from "./CargoUnitSelect.vue?vue&type=template&id=33e8ff64"
import script from "./CargoUnitSelect.vue?vue&type=script&lang=js"
export * from "./CargoUnitSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__